// Styles
import './main.css'

// Carousel
import Splide from '@splidejs/splide'
import Swiper from 'swiper/bundle'
import htmx from 'htmx.org'
window.Swiper = Swiper
window.Splide = Splide
window.htmx = htmx

// Decimals to fractions (Recipes)
import { formatQuantity } from 'format-quantity'
window.formatQuantity = formatQuantity

// Lazy image loading
import 'lazysizes'

// iFrame resizing
import iframeResize from 'iframe-resizer/js/iframeResizer.min.js'
window.iframeResize = iframeResize

// Alpine
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import persist from '@alpinejs/persist'
import intersect from '@alpinejs/intersect'

Alpine.plugin(collapse)
Alpine.plugin(focus)
Alpine.plugin(persist)
Alpine.plugin(intersect)

window.Alpine = Alpine

// Buy Titos (Alpine module)
import reservebar from './js/reservebar.js'
import usStatePicker from './js/alpine/usStatePicker.js'
import { designHuddleForm } from './js/alpine/designHuddle/designHuddleForm.js'
import { designHuddleTemplateSelection } from './js/alpine/designHuddle/designHuddleTemplateSelection.js'
import { designHuddleController } from './js/alpine/designHuddle/index.js'
import { viralSweepsForm } from './js/alpine/designHuddle/viralSweepsForm.js'
import { nonProfitTracker } from './js/alpine/nonProfitTracker.js'
import { turkeyRot } from './js/alpine/turkeyRot.js'
import { teamInvite } from './js/alpine/teamInvite.js'
import { emailSignup } from './js/alpine/emailSignup.js'
import { countdown } from './js/alpine/countdown.js'
import osanoFallback from './js/alpine/osanoFallback.js'
reservebar()

document.addEventListener('alpine:init', () => {
	Alpine.data('designHuddleForm', designHuddleForm)
	Alpine.data('designHuddleTemplateSelection', designHuddleTemplateSelection)
	Alpine.data('designHuddleController', designHuddleController)
	Alpine.data('viralSweepsForm', viralSweepsForm)
	Alpine.data('nonProfitTracker', nonProfitTracker)
	Alpine.data('turkeyRot', turkeyRot)
	Alpine.data('teamInvite', teamInvite)
	Alpine.data('emailSignup', emailSignup)
	Alpine.data('countdown', countdown)
	Alpine.data('osanoFallback', osanoFallback)
	Alpine.data('usStatePicker', usStatePicker)

	Alpine.store('global', {
		screenReaderAlert: '',
	})
})

Alpine.start()

// Formie hidden input guard (DEV-13033)
import formieHiddenInputGuard from './js/formieHiddenInputGuard.js'
formieHiddenInputGuard()

// Formie age validator
let $form = document.querySelector('form[id^=fui-]')
if ($form) {
	$form.addEventListener('onFormieThemeReady', (event) => {
		// Age Verification
		event.detail.addValidator(
			'minAge',
			({ input }) => {
				const minAge = input.getAttribute('data-age-min')

				if (!minAge) {
					return true
				}

				let $month = $form.querySelector(
					"[name='fields[birthday][month]']",
				)
				let $day = $form.querySelector("[name='fields[birthday][day]']")
				let $year = $form.querySelector(
					"[name='fields[birthday][year]']",
				)

				let $date = new Date($year.value, $month.value - 1, $day.value)
				let $today = new Date()
				$today.setHours(0, 0, 0, 0)
				$date.setHours(0, 0, 0, 0)
				const difference = $today - $date
				const age = difference / (1000 * 3600 * 24 * 365.25)
				const ageYears = Math.floor(age)

				// console.log('Age: ', ageYears);

				if (ageYears < minAge) {
					return false
				}

				return true
			},
			`You must be 21 or older to sign up.`,
		)

		event.detail.addValidator(
			'yearValidation',
			({ input }) => {
				const isYearInput = input.name == 'fields[birthday][year]'

				if (!isYearInput) {
					return true
				}

				let isValid = false
				const inputYear = input.value
				const curYear = new Date().getFullYear()

				const minYear =
					input.getAttribute('data-min-year') ?? curYear - 150

				isValid = inputYear >= parseInt(minYear) && inputYear <= curYear

				return isValid
			},
			'Year is not valid',
		)
	})
}
